var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretakerIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1311 -1659)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 10,
    transform: "translate(1311 1659)",
    fill: "#ffbe8d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.341,33.821a7.191,7.191,0,1,1,7.191-7.191A7.191,7.191,0,0,1,16.341,33.821Z",
    transform: "translate(1308.502 1652.561)",
    fill: "#621bc0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.444,31.75H9.3a.654.654,0,0,0,0,1.307H38.432L27.411,63.193l24.161-.078-11.2-30.07H69.444a.647.647,0,1,0,0-1.294Z",
    transform: "translate(1308.35 1656.344)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretakerIcon2);
export default __webpack_public_path__ + "static/media/caretaker-icon2.d38d0a7bafa6d3891de876ad046a0aa1.svg";
export { ForwardRef as ReactComponent };